<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">月份:</div>
                <el-date-picker
                v-model="conditionData.dataTime"
                type="month"
                size="small" 
                value-format="yyyy-MM"
                placeholder="选择月">
                </el-date-picker>
            </div>
            <!-- <div class="item">
                <div class="label">险种类型:</div>
                <el-select v-model="conditionData.cProdType" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany">
                    <el-option
                    v-for="item in insuranceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>

                <el-button type="success" size="small" icon="el-icon-download" @click="downloadExcel">导出数据</el-button>

            </div>
            <div class="title">
                调查员作业质量统计报表
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="600px"
                style="width: 100%">
                
                <el-table-column
                prop="city"
                label="区域"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="operator"
                label="调查员"
                align="center"
                width="80"
                >
                </el-table-column>
                <el-table-column
                prop="one"
                label="1"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="two"
                label="2"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="three"
                label="3"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="four"
                label="4"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="five"
                label="5"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="six"
                label="6"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="seven"
                label="7"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="eight"
                label="8"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="nine"
                label="9"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="ten"
                label="10"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="eleven"
                label="11"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twelve"
                label="12"
                align="center"
                width="60"
                >
                </el-table-column>
                
                <el-table-column
                prop="thirteen"
                label="13"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="fourteen"
                label="14"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="fifteen"
                label="15"
                align="center"
                width="60"
                >
                </el-table-column>




                <el-table-column
                prop="sixteen"
                label="16"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="seventeen"
                label="17"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="eighteen"
                label="18"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="nineteen"
                label="19"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twenty"
                label="20"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentyone"
                label="21"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentytwo"
                label="22"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentythree"
                label="23"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentyfour"
                label="24"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentyfive"
                label="25"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentysix"
                label="26"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentyseven"
                label="27"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentyeight"
                label="28"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="twentynine"
                label="29"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="thirty"
                label="30"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="thirtyone"
                label="31"
                align="center"
                width="60"
                >
                </el-table-column>
                <el-table-column
                prop="heji"
                label="合计"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="monthStock"
                label="当月存量"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="monthOverdue"
                label="当月超期"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="monthPositive"
                label="当月阳性"
                align="center"
                width="100"
                >
                </el-table-column>

                <el-table-column
                prop="monthOverdueRate"
                label="超期率"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="monthPositiveRate"
                label="阳性率"
                align="center"
                width="100"
                >
                </el-table-column>
            </el-table>

        </div>


        
       
    </div>
</template>
<script>
import api from '../../../api/main'
import { insuranceList} from "../../../assets/selectList/anxin";
import { parseTimeNowMM } from '../../../utils/index'

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            insuranceList:insuranceList,
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                dataTime:null,
                operatorMechanismId:localStorage.getItem('mechanismid'),
            },
            tableData:[],
        }
    },
    created(){
        

    },
    mounted(){
        this.conditionData.dataTime = parseTimeNowMM()
        this.loadingData();
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let option = {
            };
            
            if(this.conditionData.dataTime){
                option.dataTime = this.conditionData.dataTime
            }
            let res  = await api.queryDataCensusDayDcTaskQuality(option);
            console.log(res);
            this.tableData = res.data.data;
        },

        selectData(){
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                dataTime:null,
            },
            this.loadingData();
        },
        
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 9,
                "Condition":this.conditionData
            },'调查员作业质量统计报表');
        },

    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 10px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .title{
            width: 100%;
            text-align: center;
            margin-bottom: 10px;
            font-size: 18px;
            letter-spacing: 2px;
            font-weight: bold;
        }
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
